// src/utils/zodiacUtils.js
import React from 'react';
import zodiacData from '../data/zodiac-data.json';

const isDateInRange = (month, day, sign) => {
  const target = month * 100 + day;
  const start = sign.startMonth * 100 + sign.startDay;
  const end = sign.endMonth * 100 + sign.endDay;
  if (start <= end) return target >= start && target <= end;
  return target >= start || target <= end; // rango que cruza fin de año (Capricornio)
};

export const getSignByDate = (month, day) =>
  zodiacData.signs.find((sign) => isDateInRange(month, day, sign)) || null;

export const getSignByDateString = (dateStr) => {
  if (!dateStr) return null;
  const [, month, day] = dateStr.split('-').map(Number);
  return getSignByDate(month, day);
};

export const getCompatibility = (signAName, signBName) => {
  const list = zodiacData.compatibilityMatrix[signAName];
  return list ? list.find((c) => c.sign === signBName) : null;
};

// Convierte un texto con formato markdown-lite (### títulos, **negritas**) en nodos React,
// sin usar dangerouslySetInnerHTML, para evitar cualquier riesgo de inyección de HTML.
export const renderSafeMarkdown = (text) => {
  if (!text) return null;
  return text.split('\n').filter((line) => line.trim().length > 0).map((line, i) => {
    if (line.startsWith('### ')) {
      return React.createElement('h4', { key: i, className: 'oracle-h3' }, line.replace('### ', ''));
    }
    const parts = line.split(/(\*\*.*?\*\*)/g).filter(Boolean);
    return React.createElement(
      'p',
      { key: i, className: 'oracle-p' },
      parts.map((part, j) =>
        part.startsWith('**') && part.endsWith('**')
          ? React.createElement('strong', { key: j }, part.slice(2, -2))
          : part
      )
    );
  });
};
